import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CookieManagementEnum } from 'app/general/_models/cookieManagementEnum';
import { createOptionalCookie, OptionalCookie } from 'app/general/_models/optionalCookie';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CookiesManagementService } from '../../cookies-management.service';
import { NotificationService } from 'app/_services/notification.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiResponseModel } from 'app/_models/apiResponseModel';

declare const $: any;

@Component({
    selector: 'app-cookies-management-modal', templateUrl: './cookies-management-modal.component.html', styleUrls: ['./cookies-management-modal.component.scss'],
    standalone: false
})
export class CookiesManagementModalComponent implements OnInit {
    @ViewChild('templateCookiesManagementModal') template: TemplateRef<any>;
    @Output() acceptCookies: EventEmitter<number> = new EventEmitter<number>();

    isOpen: boolean = false;
    modalRef: BsModalRef;
    public optionalCookies: OptionalCookie[] = []

    constructor(private cookiesManagementService: CookiesManagementService, private notificationService: NotificationService, private ngxLoader: NgxUiLoaderService, private modalService: BsModalService, private router: Router) {}

    ngOnInit(): void {
        this.optionalCookies = [
            createOptionalCookie('google', CookieManagementEnum.Google),
        ]
    }

    async close(): Promise<void> {
        this.modalRef.hide()
        this.isOpen = false;
    }

    open() {
        let options: ModalOptions = { class: 'custom-modal modal-xsm modal-cookies', backdrop: 'static', keyboard: false };
        this.modalRef = this.modalService.show(this.template, options);
        this.isOpen = true;
    }

    openCookiePolicy() {
        const url = this.router.serializeUrl(this.router.createUrlTree([`/documentos/politica-cookies/plataforma`]));
        window.open(url, "_blank");
    }

    acceptSelectedCookies() {
        this.ngxLoader.startLoader('loader-cookie-management');

        var sumSelectedCookies = CookieManagementEnum.Essenciais + this.optionalCookies.filter(x => x.isSelected).reduce((acc, cookie) => acc + cookie.enumValue, 0);

        this.cookiesManagementService.saveUserCookieConsent(sumSelectedCookies).subscribe({
            next: (response: ApiResponseModel<{ acceptedCookies: number }>) => {
                this.notificationService.showSuccessToastr('geral.cookie-management.messages.success.accept-selected', { translateMessage: true });
                this.acceptCookies.emit(response.result.acceptedCookies);
                this.ngxLoader.stopLoader('loader-cookie-management');
                this.close();
            },
            error: () => {
                this.notificationService.showErrorToastr('geral.cookie-management.messages.error.accept-selected', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-cookie-management');
            }
        })
    }

    toggleCookieSelection(cookie: OptionalCookie) {
        cookie.isSelected =! cookie.isSelected;
    }
}
